import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAddBudgetPlanOption = (budgetPlanId, onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: `budget-plans/${budgetPlanId}/options`,
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["add-user-budget-plan-option", budgetPlanId],
    mutationFn: (budget_category_option_id) =>
      mutationFn({ data: { budget_category_option_id } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });

      onSuccess?.();
    },
  });
};
